'use strict'

define ['./optOutModal.scss'], () ->
  ($scope, $rootScope) ->
  


// WEBPACK FOOTER //
// ./components/dashboard/view/reports/optOutModal.coffee